import(/* webpackMode: "eager" */ "/codebuild/output/src2656488277/src/dharmayana-website/src/app/(pages)/festivals/layout.tsx");
